module.exports = __webpack_public_path__ + "media/promo/advent/images/logom-3-0a959ba8dc39eee5b3df63d77fdcc704.png";